import { useEffect } from "react";

import { useDispatch } from "@src/store";
import { setAiChat } from "@src/store/slices/global";

/**
 * Full-page dialogs are drawn above the page layout, so a chat rail drawn by
 * the layout would sit underneath them. While `isHosting` is true, the caller
 * draws `<AiChat />` itself and the layout draws none. The layout gets the
 * rail back when hosting stops or the caller unmounts. See `AiChat.railHost`.
 */
export const useHostAtlasRail = (isHosting: boolean) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!isHosting) {
      return;
    }
    dispatch(setAiChat({ key: "railHost", value: "embedded" }));
    return () => {
      dispatch(setAiChat({ key: "railHost", value: "shell" }));
    };
  }, [dispatch, isHosting]);
};
